exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* TODO: This doesn't really belong in colours.icss, maybe we should rename the file and combine with breakpoints.icss? We don't really have a lot in each. */\n", ""]);

// exports
exports.locals = {
	"primaryColour": "#E31836",
	"mainTextColour": "#000000",
	"inverseMainTextColour": "#ffffff",
	"secondaryColour": "#00247D",
	"pageBackgroundColour": "#ffffff",
	"mainBackgroundColour": "#e5e5e5",
	"mainPanelBackgroundColour": "#212121",
	"pagePadding": "1rem"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/colours.icss
// module id = 1
// module chunks = 0